const GROUPS_OF_PAGES = {
  home: {
    title: 'Home',
    key: 'home',
    pages: [
      {
        label: 'Home',
        value: 'home',
        path: 'home',
      },
    ],
  },
  digitize: {
    title: 'Digitize',
    key: 'digitize',
    pages: [
      {
        label: 'Digitize',
        value: 'digitize',
        path: 'digitize',
      },
      {
        label: 'Tape Transfer',
        value: 'tapeTransfer',
        path: 'tape-transfer',
      },
      {
        label: 'Photo Scanning',
        value: 'photoScan',
        path: 'photo-scan',
      },
      {
        label: 'Film transfer',
        value: 'filmTransfer',
        path: 'film-transfer',
      },
      {
        label: 'Audio Transfer',
        value: 'audioTransfer',
        path: 'convert-cassette-to-cd',
      },
      {
        label: 'Disc Transfer',
        value: 'digitalTransfer',
        path: 'dvd-to-digital-service',
      },
      // Tape Transfer subpages
      {
        label: 'VHS',
        value: 'vhs',
        path: 'vhs',
      },
      {
        label: 'VHS-C',
        value: 'vhsC',
        path: 'vhs-c',
      },
      {
        label: 'Hi-8',
        value: 'hi8',
        path: 'hi-8',
      },
      {
        label: 'Mini-DV',
        value: 'miniDV',
        path: 'mini-dv',
      },
      {
        label: 'Betamax',
        value: 'betamax',
        path: 'betamax',
      },
      {
        label: 'Pro Format',
        value: 'proFormat',
        path: 'pro-format',
      },
      // Photo Scanning subpages
      {
        label: 'Loose Photos',
        value: 'loosePhotos',
        path: 'loose-photos',
      },
      {
        label: 'Slides',
        value: 'slides',
        path: 'slides',
      },
      {
        label: 'Negatives',
        value: 'negatives',
        path: 'negatives',
      },
      {
        label: 'Photo Albums',
        value: 'photoAlbums',
        path: 'photo-albums',
      },
      {
        label: 'Document Scanning',
        value: 'documentScanning',
        path: 'document-scanning',
      },
      // Film Transfer subpages
      {
        label: '8mm Film',
        value: 'film8mm',
        path: '8mm',
      },
      {
        label: 'Super 8mm',
        value: 'filmSuper8mm',
        path: 'super-8mm',
      },
      {
        label: '16mm Film',
        value: 'film16mm',
        path: '16mm',
      },
    ],
  },
  enhance: {
    title: 'Restore',
    key: 'restore',
    pages: [
      {
        label: 'Restore',
        value: 'restore',
        path: 'restore-retouch-photo-service',
      },
      {
        label: 'Photo Restoration',
        value: 'photoRestoration',
        path: 'old-photo-restoration',
      },
      {
        label: 'Photo Colorization',
        value: 'photoColorization',
        path: 'colorize-black-and-white-photos',
      },
      {
        label: 'Photo Retouching',
        value: 'photoRetouching',
        path: 'photo-retouching-service',
      },
    ],
  },
  prints: {
    title: 'Print',
    key: 'print',
    pages: [
      {
        label: 'Print',
        value: 'print',
        path: 'create-photo-art',
      },
      {
        label: 'Story Art',
        value: 'personalized-wall-art-books',
        path: 'personalized-wall-art-books',
      },
    ],
  },
  gift: {
    title: 'Gift',
    key: 'gift',
    pages: [
      {
        label: 'Gift guide',
        value: 'giftGuide',
        path: 'gift-guide',
      },
      {
        label: 'Gift card',
        value: 'giftCard',
        path: 'gift-cards',
      },
    ],
  },
  preserve: {
    title: 'Preserve',
    key: 'preserve',
    pages: [
      {
        label: 'Preserve',
        value: 'preserve',
        path: 'genealogy-document-photo-scanning-service',
      },
      {
        label: 'Forever Cloud',
        value: 'foreverCloud',
        path: 'forever-cloud',
      },

    ],
  },
  florida: {
    title: 'Florida',
    key: 'florida',
    pages: [
      {
        label: 'Florida',
        value: 'florida',
        path: 'south-florida-media-digitizing-service',
      },
      {
        label: 'Florida Tape Transfer',
        value: 'floridaTapeTransfer',
        path: 'south-florida-vhs-tape-transfer-service',
      },
      {
        label: 'Florida Photo Scan',
        value: 'floridaPhotoScan',
        path: 'south-florida-old-photo-scanning-service',
      },
      {
        label: 'Florida Film Transfer',
        value: 'floridaFilmTransfer',
        path: 'south-florida-film-transfer-service',
      },
      {
        label: 'Florida Audio Transfer',
        value: 'floridaAudioTransfer',
        path: 'south-florida-cassette-conversion-service',
      },
      {
        label: 'Florida Media Transfer',
        value: 'floridaMediaTransfer',
        path: 'south-florida-media-digitizing-service',
      },
      {
        label: 'Boca Raton frame shop',
        value: 'bocaRatonFrameStoreGiftShop',
        path: 'boca-raton-frame-store-gift-shop',
      },
    ],
  },
  info: {
    title: 'Info',
    key: 'info',
    pages: [
      {
        label: 'Business Services',
        value: 'businessServices',
        path: 'professional-media-archiving-printing',
      },
      {
        label: 'How It Works',
        value: 'howItWorks',
        path: 'how-digitizing-and-enhancing-works',
      },
      {
        label: 'Our mission',
        value: 'ourMission',
        path: 'our-team',
      },
      {
        label: 'Our story',
        value: 'ourStory',
        path: 'our-story',
      },
      {
        label: 'Contact',
        value: 'contact',
        path: 'contact',
      },
      {
        label: 'Reviews',
        value: 'reviews',
        path: 'reviews',
      },
      {
        label: 'FAQs',
        value: 'forever-care',
        path: 'forever-care',
      },
      {
        label: 'Blogs',
        value: 'blog',
        path: 'blog',
      },
    ],
  },
  commercial: {
    title: 'Pod',
    key: 'commercial',
    pages: [
      {
        label: 'pod - commercial',
        value: 'pod',
        path: 'pod',
      },
      {
        label: 'Print on Demand',
        value: 'printOnDemand',
        path: 'print-on-demand',
      },
    ],
  },
};

export default GROUPS_OF_PAGES;
